import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ChemistAddtionalApprovalComponent } from "./chemistaddtionalapproval/chemistaddtionalapproval.component";
import { DcrUnlockApprovalComponent } from "./dcrunlockapproval/dcrunlockapproval.component";
import { IMEIResetComponent } from "./imeireset/imeireset.component";
import { LateDayplanApprovalComponent } from "./latedayplanapproval/latedayplanapproval.component";
import { RouteAddtionalApprovalComponent } from "./routeaddtionalapproval/routeaddtionalapproval.component";
import { RouteDivertApprovalComponent } from "./routedivertapproval/routedivertapproval.component";
import { TPAddEditApprovalComponent } from "./tpaddeditapproval/tpaddeditapproval.component";
import { AuthGuard } from '../../components/auth/auth-guard.service';
const mainRoutes: Routes = [

    { path: 'chemistadditionalapproval', canActivate: [AuthGuard], component: ChemistAddtionalApprovalComponent },
    { path: 'dcrunlockapproval', canActivate: [AuthGuard], component: DcrUnlockApprovalComponent },
    { path: 'latedayplanapproval', canActivate: [AuthGuard], component: LateDayplanApprovalComponent },
    { path: 'routeadditionapproval', canActivate: [AuthGuard], component: RouteAddtionalApprovalComponent },
    { path: 'routedivertapproval', canActivate: [AuthGuard], component: RouteDivertApprovalComponent },
    { path: 'tpaddeditapproval', canActivate: [AuthGuard], component: TPAddEditApprovalComponent },
    { path: 'imeireset', canActivate: [AuthGuard], component: IMEIResetComponent },

]
@NgModule({
    imports: [RouterModule.forChild(mainRoutes)],
    exports: [RouterModule]
})
export class ApprovalsRoutingModule {

}